function announcementBar() {
  const announcementSlider = document.querySelector('.announcement-bar__slider');

  if (!announcementSlider) return;

  const { autoplay, delay } = announcementSlider.dataset;

  new Swiper(announcementSlider, {
    slidesPerView: 1,
    loop: true,
    ...(autoplay === "true" && {
      autoplay: {
        delay: (Number(delay) * 1000) || 50000,
      }
    })
  });
}

announcementBar();